export default __webpack_public_path__ + "static/media/AI-Automation-Services.adad5df0.png";